import { render, staticRenderFns } from "./Monstrik.vue?vue&type=template&id=7c8cd2f0&scoped=true&"
import script from "./Monstrik.vue?vue&type=script&lang=js&"
export * from "./Monstrik.vue?vue&type=script&lang=js&"
import style0 from "./Monstrik.vue?vue&type=style&index=0&id=7c8cd2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8cd2f0",
  null
  
)

export default component.exports